import React, { useState } from 'react';
import { MdClose, MdLocationOn } from 'react-icons/md';
import axios from 'axios';
import { API_BASE_URL as DEFAULT_API_BASE_URL, API_CONFIG } from '../../config/api';

const AddZoneModal = ({ isOpen, onClose, showPopup, fetchData, API_BASE_URL, userMmdaId, onSuccess, onError }) => {
  // Use prop API_BASE_URL if provided, otherwise use default from config
  const apiBaseUrl = API_BASE_URL || DEFAULT_API_BASE_URL;
  const [formData, setFormData] = useState({
    zone_name: '',
    description: '',
    status: 'active',
  });
  const [loading, setLoading] = useState(false);

  const config = {
    headers: {
      'Authorization': 'Basic ' + btoa('Techland:Techland@24'),
      'Content-Type': 'application/json',
    },
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Add MMDA ID to the zone data
      const zoneData = {
        ...formData,
        mmda_id: userMmdaId,
      };

      const response = await axios.post(`${apiBaseUrl}/zones`, zoneData, config);
      
      if (response.status === 201) {
        setFormData({
          zone_name: '',
          description: '',
          status: 'active',
        });
        onClose();

        // Show success modal
        if (onSuccess) {
          onSuccess('Created', 'Zone', formData.zone_name, 'Zone has been created and is now available for officer assignments.');
        } else {
          showPopup('Zone created successfully!', 'success');
          fetchData();
        }
      }
    } catch (error) {


      // Show error modal
      if (onError) {
        onError('Create', 'Zone', formData.zone_name, error.response?.data?.error || error.message);
      } else {
        showPopup(error.response?.data?.error || 'Failed to create zone', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      zone_name: '',
      description: '',
      status: 'active',
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 8,
        padding: 24,
        width: '90%',
        maxWidth: 500,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 15,
          borderBottom: '2px solid #e0e0e0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <MdLocationOn size={24} style={{ color: '#1976d2' }} />
            <h2 style={{ margin: 0, color: '#1976d2', fontSize: 20 }}>Add New Zone</h2>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 5,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdClose size={24} style={{ color: '#666' }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{
              display: 'block',
              marginBottom: 5,
              fontWeight: 'bold',
              color: '#333',
              fontSize: 14,
            }}>
              Zone Name *
            </label>
            <input
              type="text"
              name="zone_name"
              value={formData.zone_name}
              onChange={handleInputChange}
              required
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ccc',
                borderRadius: 4,
                fontSize: 14,
                outline: 'none',
                boxSizing: 'border-box',
              }}
              placeholder="Enter zone name"
            />
          </div>



          <div style={{ marginBottom: 16 }}>
            <label style={{
              display: 'block',
              marginBottom: 5,
              fontWeight: 'bold',
              color: '#333',
              fontSize: 14,
            }}>
              Description
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows={3}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ccc',
                borderRadius: 4,
                fontSize: 14,
                outline: 'none',
                boxSizing: 'border-box',
                resize: 'vertical',
              }}
              placeholder="Enter zone description"
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{
              display: 'block',
              marginBottom: 5,
              fontWeight: 'bold',
              color: '#333',
              fontSize: 14,
            }}>
              Status
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ccc',
                borderRadius: 4,
                fontSize: 14,
                outline: 'none',
                boxSizing: 'border-box',
                backgroundColor: 'white',
              }}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          {/* Regional Info */}
          <div style={{
            padding: 12,
            backgroundColor: '#e3f2fd',
            borderRadius: 6,
            marginBottom: 20,
            fontSize: 13,
            color: '#1976d2',
          }}>
            <strong>Note:</strong> This zone will be created within your MMDA region and will be available for revenue officer assignments.
          </div>

          {/* Buttons */}
          <div style={{
            display: 'flex',
            gap: 10,
            justifyContent: 'flex-end',
          }}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                padding: '10px 20px',
                border: '1px solid #ccc',
                borderRadius: 4,
                backgroundColor: 'white',
                color: '#666',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 'bold',
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: 4,
                backgroundColor: loading ? '#ccc' : '#1976d2',
                color: 'white',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: 14,
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              {loading ? 'Creating...' : 'Create Zone'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddZoneModal;
